export default __webpack_public_path__ + "static/1-56b13351716410bc8dc988bffa6001fc.png";